import React from 'react'
import * as S from './styles'
import { currencyParser } from '../../../../utils'

const SummaryUserPix = ({ data, refundSummary }) => {
  const pixTypeLabels = {
    phone: 'Telefone',
    email: 'E-mail',
    cpf: 'CPF',
    random: 'Chave aleatória'
  }

  return (
    <S.CardRequestValueContainer>
      <S.CardRequestAccount>
        <span>Valor: </span> {currencyParser(refundSummary?.refundAmount, 'R$ ')}
      </S.CardRequestAccount>
      <S.CardRequestAccount>
        <span>Beneficiário: </span> {data.pixData?.recipient}
      </S.CardRequestAccount>
      <S.CardRequestAccount>
        <span>CPF: </span> {data.pixData?.CPF}
      </S.CardRequestAccount>
      <S.CardRequestAccount>
        <span>Tipo da chave PIX: </span> {pixTypeLabels[data.pixData?.pixType]}
      </S.CardRequestAccount>
      <S.CardRequestAccount>
        <span>Chave PIX: </span> {data.pixData?.pixKey}
      </S.CardRequestAccount>
    </S.CardRequestValueContainer>
  )
}

export default SummaryUserPix
